/* @flow */

export const FETCH_SUPPORT_QUESTIONS_REQUEST =
  'FETCH_SUPPORT_QUESTIONS_REQUEST';
export const FETCH_SUPPORT_QUESTIONS_SUCCESS =
  'FETCH_SUPPORT_QUESTIONS_SUCCESS';
export const FETCH_SUPPORT_QUESTIONS_FAILURE =
  'FETCH_SUPPORT_QUESTIONS_FAILURE';

export const PATCH_SUPPORT_QUESTION_REQUEST = 'PATCH_SUPPORT_QUESTION_REQUEST';
export const PATCH_SUPPORT_QUESTION_SUCCESS = 'PATCH_SUPPORT_QUESTION_SUCCESS';
export const PATCH_SUPPORT_QUESTION_FAILURE = 'PATCH_SUPPORT_QUESTION_FAILURE';

export const SIMULATE_SUPPORT_QUESTION_FETCH =
  'SIMULATE_SUPPORT_QUESTION_FETCH';
